/**
 * Connect POS Desktop (Electron ≥1.1.0): envío ESC/POS RAW a la cola de Windows.
 * Funciona con cualquier tiquera USB y cualquier driver (incluido "Generic / Text Only").
 * Reutiliza los builders ESC/POS aprobados (QR raster GS v 0 + espaciado anti-corte).
 */
import { buildTicketBytes, buildRechargeBytes, buildSeguroBytes } from "@/lib/bluetoothPrint";
import { getPrinterSettings } from "@/lib/printerConfig";

export const isDesktopApp = () => typeof window !== "undefined" && !!window.electronAPI?.isElectron;
export const desktopSupportsRaw = () => isDesktopApp() && typeof window.electronAPI.printRaw === "function";
// RAW activo: app de escritorio con soporte y modo "raw" (por defecto).
export const isDesktopRawActive = () => desktopSupportsRaw() && getPrinterSettings().desktop_mode !== "graphic";

// Impresión gráfica del sistema: en la app de escritorio usa silentPrint (sin diálogo); en navegador window.print.
export const systemPrint = () => (isDesktopApp() && window.electronAPI.silentPrint ? window.electronAPI.silentPrint() : window.print());

async function send(build) {
  try {
    const res = await window.electronAPI.printRaw(build());
    return res?.ok ? { ok: true, device: { name: res.printer } } : { ok: false, error: res?.error || "Error de impresión" };
  } catch (e) {
    return { ok: false, error: e?.message || String(e) };
  }
}

export const printTicketViaDesktop = (ticket, ctx = {}) => send(() => buildTicketBytes(ticket, ctx));
export const printRechargeViaDesktop = (rec, ctx = {}) => send(() => buildRechargeBytes(rec, ctx));
export const printSeguroViaDesktop = (seg, ctx = {}) => send(() => buildSeguroBytes(seg, ctx));
